import { useQuery } from "@tanstack/react-query";
import { request } from "../types/request.ts";

export const useHealthCheck = () => {
  return useQuery({
    queryKey: ["healthCheck"],
    queryFn: async () => {
      const response = await request<any>("/health");
      return response?.data?.[0]?.success === true;
    },
  });
};
